import { keepPreviousData } from '@tanstack/react-query';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import {
  getTeamsPendingDeletionApi,
  GetTeamsPendingDeletionResponse,
} from 'TeamModule/services/GetTeamsPendingDeletionApi';
import { SearchTeamsByFieldsPayload } from 'TeamModule/api/searchTeamsByFieldsApi';
import { teamQueryKeys } from '../teamQueryKeys';

export const useTeamsPendingDeletionQuery = (params: SearchTeamsByFieldsPayload) => {
  const { data: queryData, ...query } = useAppQuery<{
    data: GetTeamsPendingDeletionResponse;
  }>({
    queryKey: teamQueryKeys.list({ identifier: `useTeamsPendingDeletionQuery`, ...params }),
    queryFn: ({ token, buildConfig }) =>
      getTeamsPendingDeletionApi({ params, token, config: buildConfig() }) as Promise<{
        data: GetTeamsPendingDeletionResponse;
      }>,
    staleTime: 30000, // 30 seconds - prevents aggressive refetching
    gcTime: 5 * 60 * 1000, // 5 minutes - keep cached data longer
    refetchOnMount: false, // Don't refetch on component mount if data exists
    placeholderData: keepPreviousData, // Keep previous data while fetching to prevent UI flicker
  });

  return { teamsPendingDeletion: queryData?.data, ...query };
};
